
export const getRoleSimpleList = () => ['farrier', 'veterinarian', 'staff', 'admin', 'owner'];
export const getRoleList = () => ['farrier', 'veterinarian', 'staff', 'admin', 'owner'];

export const getRoleDescription = (role) => {
  switch (role) {
    case 'farrier':
      return (
        <div>
          Users with this role will have access to horses and their tasks including any farrier tasks.
        </div>
      );
    case 'veterinarian':
      return (
        <div>
          Users with this role will be able to view health information about the horses in your barn.
        </div>
      );
    case 'staff':
      return (
        <div>
          Users with this role have basic access to the Questri Barn and data in order to perform assigned duties.
          These individuals have access to the barn board and tasks page where they will be able to provide updates to their assigned work.
          In addition, staff can view data about horses at the barn, and add their own horse notes.
          <div>
            <small>Slightly elevated permissions on top on top of the general user role, more access to horse data/modifications.</small>
          </div>
        </div>
      );
    case 'admin':
      return (
        <div>
          Users with this role can access the settings pages and features including:
          Modifying Users and/or access, modifying Barn Settings (locations, feeds, tasks, schedules),
          modifying horses and associated data/settings. In addition, admins can override data associated with generated tasks.
          <div>
            <small>Elevated permissions on top of the staff role.</small>
          </div>
        </div>
      );
    case 'owner':
      return (
        <div>
          Users with this role can access billing information
          and other sensitive features for the Questri Barn.
          <div>
            <small>There must be at least one owner in the Questri Barn at all times.</small>
          </div>
        </div>
      );
    default:
      return <div>Not a valid role</div>;
  }
};

export const getRoleFeatures = (role) => {
  switch (role) {
    case 'farrier':
      return ['Basic user features including access to horse tasks and farrier information'];
    case 'veterinarian':
      return ['Basic user features including access to horse health information'];
    case 'staff':
      return ['View Barn Board', 'View Tasks', 'Initiate New Tasks', 'Update Tasks', 'View Horses', 'Add Horse Notes', 'Access/Update User Profile & Preferences', 'Great for grooms or temporary staff'];
    case 'admin':
      return ['Same features as Staff plus…', 'Add or remove users from Questri Barn', 'Create or update settings (locations, feeds, tasks)', 'Create or update horses', 'Override tasks', 'Ideal for barn managers'];
    case 'owner':
      return ['Same features as Staff and Admin plus…', 'Update Questri Barn settings', 'Update Questri subscription billing information'];
    default:
      return ['Not a valid role'];
  }
};

export const formatStringOfRolesIntoArray = (rolesString) => {
  if (rolesString === undefined || rolesString === null || rolesString === '' || rolesString === '[]') {
    return [];
  }
  let parsedRoleString = rolesString.replace('[', '');
  parsedRoleString = parsedRoleString.replace(']', '');
  parsedRoleString = parsedRoleString.replace(/\s/g, '');
  return parsedRoleString.split(',');
};
